import {
  GoalBasedPlanDateType,
  GoalBasedRepeatTimeFrame,
  GoalBasedRepeatTimeFrameLabel,
} from "@fartherfinance/frontend/api/FinancialPlans/types";
import { ClientId } from "@fartherfinance/frontend/api/Types";

import {
  CalendarYearEndField,
  CalendarYearStartField,
  EndsField,
  FinancingMethods,
  OwnerField,
  RepeatsField,
  SpousesAgeEndField,
  SpousesAgeStartField,
  StartsField,
  TargetDateField,
  YourAgeEndField,
  YourAgeStartField,
} from "./constants";
import { AnnualIncreaseFields } from "./MultiDropdown/AnnualIncrease/AnnualIncrease";

export enum DateRangeRepeatsTextStrings {
  Until = "until",
  From = "from",
  Starting = "starting",
}

type PlanDateDropdownLabelEnums =
  | "Already Started"
  | "Calendar Year"
  | "Your Retirement"
  | "End of Your Planning Horizon"
  | "Your Age"
  | "Spouse's Retirement"
  | "End of Spouse's Planning Horizon"
  | "Spouse's Age";

type PlanDateDropdownValueEnums =
  | "AlreadyStarted"
  | "CalendarYear"
  | "YourRetirement"
  | "EndOfYourPlanningHorizon"
  | "YourAge"
  | "SpouseRetirement"
  | "EndOfSpousePlanningHorizon"
  | "SpouseAge";

interface RepeatsField {
  label: GoalBasedRepeatTimeFrameLabel;
  value: GoalBasedRepeatTimeFrame;
}

export type FinancingMethod = typeof FinancingMethods[number];

type PlanDateDropdownLabelEnum = PlanDateDropdownLabelEnums;

export type PlanDateDropdownValueEnum = PlanDateDropdownValueEnums;

export interface PlanDateTypeOptionsDropdown {
  label: PlanDateDropdownLabelEnum;
  value: PlanDateDropdownValueEnum;
  dateType: GoalBasedPlanDateType;
}

export interface OwnerFieldType {
  label: string;
  value: ClientId;
}

export interface InitialPlanDateFieldValuesAndOwnerField
  extends RepeatDropdownFormFieldTypes {
  [OwnerField]: OwnerFieldType;
}

export type InitialPlanDateOwnerAndAnnualIncreaseFields =
  InitialPlanDateFieldValuesAndOwnerField & AnnualIncreaseFields;

export type RepeatDropdownFormFieldTypes = {
  [RepeatsField]: RepeatsField;
  [TargetDateField]: Date | undefined;
  [StartsField]: PlanDateTypeOptionsDropdown;
  [EndsField]: PlanDateTypeOptionsDropdown;
  [CalendarYearStartField]: string | undefined;
  [YourAgeStartField]: string | undefined;
  [SpousesAgeStartField]: string | undefined;
  [CalendarYearEndField]: string | undefined;
  [YourAgeEndField]: string | undefined;
  [SpousesAgeEndField]: string | undefined;
};
